import {PcbNode, PcbNodeTypes, createActionRecordAction} from "@buildwithflux/core";

export const updateRouteSegments = createActionRecordAction(
    // QUESTION: why is this mixed plural and singular?
    "updateRouteSegment",
    (updates: {[uid: string]: PcbNode<PcbNodeTypes.routeSegment>}) => {
        return {
            payload: {
                updates,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
                // NOTE: assume the worst
                hasInheritedRules: true,
                hasInheritedCalculations: true,
                requiresDescendantRebake: true,
                requiresNetDescendantRebake: true,
            },
        };
    },
    "updated route segment",
);
